import React, { useEffect, useState } from "react";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import { Formik, Form, FieldArray } from "formik";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomSelect from "../../../CustomComponent/custom_select";
import StepRoutes from "../../../Routes/steps_routes";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import LoadingPage from "../../../Components/layouts/loading";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import {
  ServiceOrderSchema,
  serviceLineItemSchema,
} from "../../../Schemas/purchase/service_order_schema";
import { roundOffCost } from "../../../Components/Functions/amt.fun";
import {
  ServiceOrderInfo,
  serviceLineItemInfo,
} from "../../../SchemaInfo/info";
import { getId } from "../../../Components/Functions/word.fun";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";

const AddServiceOrder = () => {
  let userData = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const [vendors, setVendors] = useState([]);
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [data, setData] = useState([]);
  const [serviceOrder, setServiceOrderInfo] = useState(ServiceOrderInfo);

  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const queryId = searchParams.get("duplicate");
    const today = new Date();

    if (queryId) {
      setLoading(true);
      performRequest("GET", `/poDcPi/getPoDcPiById/${queryId}`)
        .then((res) => {
          if (res.status === 200) {
            let { serviceOrderNumber, ...data } = res.data;
            data = { ...data, lineItems: data.lineItems || [] };
            setServiceOrderInfo(data);
          } else {
            Toast("error", "Error while getting PO!");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  }, [location.search]);

  useEffect(() => {
    performRequest("GET", "/materialPlanning/getAllMaterialList")
      .then((res) => {
        if (res.status === 200) {
          setData(res.data?.MaterialList);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);
  useEffect(() => {
    performRequest("GET", "/siteInspection/getAllProjects")
      .then((res) => setProjects(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  const handelSubmit = (values, actions) => {
    values = { ...values, generatedBy: userData.Name };
    let CompData = values?.lineItems?.map((item, index) => {
      return {
        ...item,
        totalWithGst:
          +item.itemQuantity * +item.itemPrice -
          (+item.itemQuantity * +item.itemPrice * +item.discount) / 100 +
          ((+item.itemQuantity * +item.itemPrice -
            (+item.itemQuantity * +item.itemPrice * +item.discount) / 100) *
            +item.gstRate) /
            100,
        totalWithoutGst:
          +item.itemQuantity * +item.itemPrice -
          (+item.itemQuantity * +item.itemPrice * +item.discount) / 100,
      };
    });

    values = { ...values, lineItems: CompData };

    const formData = new FormData();
    for (let key in values) {
      if (key === "lineItems") {
        values.lineItems.forEach((task, index) => {
          for (let field in task) {
            formData.append(`lineItems[${index}][${field}]`, task[field]);
          }
        });
      } else {
        formData.append(key, values[key]);
      }
    }

    setLoading(true);
    performRequest("POST", "/serviceOrder/createServiceOrder", formData, {
      "Content-Type": "multipart/form-data",
    })
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Service Order created successfully!");
          navigate(`/service-order`);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    performRequest("GET", "/serviceOrder/getAllVendorList")
      .then((res) => setVendors(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  const checkTouched = (obj) => {
    if (
      obj.deliveryDate === "" &&
      obj.gstRate === "" &&
      obj.itemPrice === "" &&
      obj.itemQuantity === "" &&
      obj.itemUnit === "" &&
      obj.notes === "" &&
      obj.particulars === ""
    ) {
      return false;
    } else {
      return true;
    }
  };
  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">Purchase Management</h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">New Service Order</h2>
            </div>

            <Formik
              initialValues={serviceOrder}
              validationSchema={ServiceOrderSchema}
              onSubmit={handelSubmit}
            >
              {(props) => (
                <Form>
                  {console.log("props is", props)}

                  <div className="card-body">
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Vendor Service Order For
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="vendorServiceOrderFor">
                          <option value="">Select</option>
                          <option value="for client">For Client</option>
                          <option value="for stocking">For Stocking</option>
                        </CustomSelect>
                        {props.touched.vendorServiceOrderFor &&
                          props.errors.vendorServiceOrderFor && (
                            <p className="text-danger">
                              {props.errors.vendorServiceOrderFor}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Vendor Service Order Date
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="date"
                          name="vendorServiceOrderDate"
                        />

                        {props.touched.vendorServiceOrderDate &&
                          props.errors.vendorServiceOrderDate && (
                            <p className="text-danger">
                              {props.errors.vendorServiceOrderDate}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Country of supply
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="countryOfSupply">
                          <option value="">Select Country</option>
                          <option value="india">India</option>
                        </CustomSelect>

                        {props.touched.countryOfSupply &&
                          props.errors.countryOfSupply && (
                            <p className="text-danger">
                              {props.errors.countryOfSupply}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Place of supply
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="placeOfSupply" />

                        {props.touched.placeOfSupply &&
                          props.errors.placeOfSupply && (
                            <p className="text-danger">
                              {props.errors.placeOfSupply}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Vendor
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="vendor">
                          <option value="">Select</option>
                          {vendors?.map((item) => {
                            return (
                              <option key={item.id} value={item.id}>
                                {item.businessName}
                              </option>
                            );
                          })}
                        </CustomSelect>

                        {props.touched.vendor && props.errors.vendor && (
                          <p className="text-danger">{props.errors.vendor}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Vendor invoice number
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="vendorInvoiceNumber" />

                        {props.touched.vendorInvoiceNumber &&
                          props.errors.vendorInvoiceNumber && (
                            <p className="text-danger">
                              {props.errors.vendorInvoiceNumber}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Payment priority
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="paymentPriority">
                          <option value="">Select</option>
                          <option value="high">High</option>
                          <option value="low">Low</option>
                        </CustomSelect>

                        {props.touched.paymentPriority &&
                          props.errors.paymentPriority && (
                            <p className="text-danger">
                              {props.errors.paymentPriority}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Payment Type
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="paymentType">
                          <option value="">Select</option>
                          <option value="onetime">One time</option>
                          <option value="partially">Partially</option>
                        </CustomSelect>

                        {props.touched.paymentType &&
                          props.errors.paymentType && (
                            <p className="text-danger">
                              {props.errors.paymentType}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Payment amount (rs)
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="paymentAmount" />

                        {props.touched.paymentAmount &&
                          props.errors.paymentAmount && (
                            <p className="text-danger">
                              {props.errors.paymentAmount}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Proforma invoice
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="performaInvoice"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "performaInvoice",
                              e.target.files[0],
                            )
                          }
                        />
                        {props.touched.performaInvoice &&
                          props.errors.performaInvoice && (
                            <p className="text-danger">
                              {props.errors.performaInvoice}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Tax invoice
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="taxInvoice"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue("taxInvoice", e.target.files[0])
                          }
                        />
                        {props.touched.taxInvoice &&
                          props.errors.taxInvoice && (
                            <p className="text-danger">
                              {props.errors.taxInvoice}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Project
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="project">
                          <option value="">Select</option>
                          {projects &&
                            projects?.map((pro) => {
                              return (
                                <option
                                  key={pro.cpNumber}
                                  value={getId(pro.cpNumber)}
                                >
                                  {pro.clientName}
                                </option>
                              );
                            })}
                        </CustomSelect>

                        {props.touched.project && props.errors.project && (
                          <p className="text-danger">{props.errors.project}</p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Notes</label>
                      <div className="w-100 col">
                        <CustomTextArea type="text" name="notes" />

                        {props.touched.notes && props.errors.notes && (
                          <p className="text-danger">{props.errors.notes}</p>
                        )}
                      </div>
                    </div>
                    <hr />
                    <h3>Line Items :</h3>
                    <hr />
                    <FieldArray name="lineItems">
                      {({ push, remove }) => (
                        <div>
                          {props.values.lineItems.map((lineItem, index) => (
                            <div key={index}>
                              <div className="row g-3 align-items-center">
                                {props?.values?.lineItems?.[index]?.itemFrom !==
                                  "inventory" && (
                                  <div className="col-md">
                                    <label className=" form-label">
                                      Particulars:
                                    </label>
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="text"
                                        name={`lineItems[${index}].particulars`}
                                      />
                                    </div>
                                  </div>
                                )}
                                {props?.values?.lineItems?.[index]?.itemFrom ===
                                  "inventory" && (
                                  <div className="col-md">
                                    <label className=" form-label ">
                                      Particulars
                                    </label>

                                    <div className="w-100 col">
                                      <CustomSelect
                                        type="text"
                                        name={`lineItems[${index}].particulars`}
                                        value={
                                          props?.values?.lineItems?.[index]?.id
                                        }
                                        onChange={(e) => {
                                          let item = data?.find(
                                            (el) => el.id == e.target.value,
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].particulars`,
                                            item?.item,
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].id`,
                                            item?.id,
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].hsn`,
                                            item?.hsn,
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].itemUnit`,
                                            item?.unit,
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].itemPrice`,
                                            item?.cost,
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].sku`,
                                            item?.sku,
                                          );
                                        }}
                                      >
                                        <option value="">Select</option>
                                        {data?.map((el) => {
                                          return (
                                            <option key={el.id} value={el?.id}>
                                              {el?.item}
                                            </option>
                                          );
                                        })}
                                      </CustomSelect>
                                    </div>
                                  </div>
                                )}
                                {props?.values?.lineItems?.[index]?.itemFrom ===
                                  "inventory" && (
                                  <div className="col-md">
                                    <label className=" form-label">SKU</label>
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="text"
                                        name={`lineItems[${index}].sku`}
                                      />
                                    </div>
                                  </div>
                                )}
                                <div className="col-md">
                                  <label className=" form-label ">
                                    Item units
                                  </label>

                                  <div className="w-100 col">
                                    <CustomSelect
                                      type="text"
                                      name={`lineItems[${index}].itemUnit`}
                                    >
                                      <option value="">Select</option>
                                      <option value="nos">Nos</option>
                                      <option value="kg">Kg</option>
                                      <option value="grams">Grams</option>
                                      <option value="ltr">Litter</option>
                                      <option value="ml">ML</option>
                                      <option value="packs">Packs</option>
                                      <option value="pair">Pair</option>
                                      <option value="sqm">SqM</option>
                                      <option value="sqft">SqFt</option>
                                      <option value="mts">Meters</option>
                                      <option value="pcs">Pices</option>
                                    </CustomSelect>
                                  </div>
                                </div>
                                <div className="col-md">
                                  <label className=" form-label ">
                                    Quantity
                                  </label>
                                  <div className="w-100 col">
                                    <CustomInput
                                      type={"text"}
                                      name={`lineItems[${index}].itemQuantity`}
                                    />
                                  </div>
                                </div>
                                {/* {props?.values?.lineItems?.[index]?.itemFrom ===
                                  "inventory" && (
                                  <div className="col-md">
                                    <label className=" form-label">HSN:</label>
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="text"
                                        name={`lineItems[${index}].hsn`}
                                      />
                                    </div>
                                  </div>
                                )} */}

                                <div className="col-md">
                                  <label className=" form-label ">
                                    Item price
                                  </label>
                                  <div className="w-100 col">
                                    <CustomInput
                                      type="text"
                                      name={`lineItems[${index}].itemPrice`}
                                    />
                                  </div>
                                </div>

                                <div className="col-md">
                                  <label className=" form-label ">
                                    GST (%)
                                  </label>
                                  <div className="w-100 col">
                                    <CustomSelect
                                      type="text"
                                      name={`lineItems[${index}].gstRate`}
                                    >
                                      <option value="">Select</option>
                                      <option value="0">0 %</option>
                                      <option value="5">5%</option>
                                      <option value="12">12%</option>
                                      <option value="18">18%</option>
                                      <option value="28">28%</option>
                                      <option value="100">100%</option>
                                    </CustomSelect>
                                  </div>
                                </div>
                                <div className="col-md">
                                  <label className=" form-label ">
                                    Delivery date
                                  </label>
                                  <div className="w-100 col">
                                    <CustomInput
                                      name={`lineItems[${index}].deliveryDate`}
                                      type="date"
                                    ></CustomInput>
                                  </div>
                                </div>
                              </div>
                              <div className="row g-3 align-items-center">
                                <div className="col-md">
                                  <label className=" form-label ">
                                    Discount
                                  </label>
                                  <div className="w-100 col">
                                    <CustomInput
                                      type={"text"}
                                      name={`lineItems[${index}].discount`}
                                    />
                                  </div>
                                </div>
                                <div className="col-md">
                                  <label className=" form-label ">Note</label>
                                  <div className="w-100 col">
                                    <CustomTextArea
                                      type={"text"}
                                      name={`lineItems[${index}].notes`}
                                    />
                                  </div>
                                </div>

                                <div className="col-md">
                                  <label className=" form-label ">
                                    Amount (excl GST)
                                  </label>
                                  <div className="w-100 col">
                                    {roundOffCost(
                                      lineItem.itemQuantity *
                                        lineItem.itemPrice -
                                        (lineItem.itemQuantity *
                                          lineItem.itemPrice *
                                          lineItem.discount) /
                                          100,
                                    )}
                                  </div>
                                </div>
                                {/* add po */}
                                <div className="col-md">
                                  <label className=" form-label ">
                                    Amount (Inc GST):
                                  </label>
                                  <div className="w-100 col">
                                    {roundOffCost(
                                      lineItem.itemQuantity *
                                        lineItem.itemPrice -
                                        (lineItem.itemQuantity *
                                          lineItem.itemPrice *
                                          lineItem.discount) /
                                          100 +
                                        ((lineItem.itemQuantity *
                                          lineItem.itemPrice -
                                          (lineItem.itemQuantity *
                                            lineItem.itemPrice *
                                            lineItem.discount) /
                                            100) *
                                          lineItem.gstRate) /
                                          100,
                                    )}
                                  </div>
                                </div>
                                <div className="col-md">
                                  <button
                                    className="col-3 btn btn-primary"
                                    style={{
                                      width: "70px",
                                      height: "30px",
                                    }}
                                    type="button"
                                    onClick={() => remove(index)}
                                  >
                                    Remove
                                  </button>
                                </div>
                              </div>
                              <hr />
                            </div>
                          ))}

                          <button
                            className="btn btn-primary mt-2 me-2"
                            type="button"
                            onClick={() => {
                              if (props.values.lineItems.length === 0) {
                                push({
                                  ...serviceLineItemInfo,
                                });
                              } else if (
                                props.values.lineItems.length > 0 &&
                                checkTouched(
                                  props.values.lineItems[
                                    props.values.lineItems.length - 1
                                  ],
                                )
                              ) {
                                push(serviceLineItemInfo);
                              } else {
                                Toast(
                                  "error",
                                  "Please fill at least one line item field.",
                                );
                              }
                            }}
                          >
                            Add Inventory Item
                          </button>
                          <button
                            className="btn btn-primary mt-2"
                            type="button"
                            onClick={() => {
                              if (props.values.lineItems.length === 0) {
                                push({
                                  ...serviceLineItemInfo,
                                  itemFrom: "custom",
                                });
                              } else if (
                                props.values.lineItems.length > 0 &&
                                checkTouched(
                                  props.values.lineItems[
                                    props.values.lineItems.length - 1
                                  ],
                                )
                              ) {
                                push({
                                  ...serviceLineItemInfo,
                                  itemFrom: "custom",
                                });
                              } else {
                                Toast(
                                  "error",
                                  "Please fill at least one line item field.",
                                );
                              }
                            }}
                          >
                            Add Custom Line Item
                          </button>
                        </div>
                      )}
                    </FieldArray>
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="Create Purchase Order" />

                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default AddServiceOrder;
